import React, { useEffect } from 'react';
import useOnScreen from '../../../hooks/use-on-screen';
import { Box } from '@mui/material';

const InfiniteScrollContainer = ({
    hasEnd,
    hasStart,
    isLoadingStart,
    isLoadingEnd,
    loadStart,
    loadEnd,
    data,
    Component,
}) => {
    const { measureStartRef, measureEndRef, isStartIntersecting, isEndIntersecting, startObserver, endObserver } =
        useOnScreen();

    useEffect(() => {
        if (isEndIntersecting && hasEnd) {
            loadEnd();
            endObserver.disconnect();
        }
    }, [isEndIntersecting, hasEnd, loadEnd]);

    useEffect(() => {
        if (isStartIntersecting && hasStart) {
            loadStart();
            startObserver.disconnect();
        }
    }, [isStartIntersecting, hasStart, loadStart]);

    return (
        <Box>
            {isLoadingStart && <Box textAlign={'center'}>Loading...</Box>}
            {data.map((item, index) => {
                if (index === data.length - 1) {
                    return (
                        <Box key={item.id} ref={measureEndRef}>
                            <Component {...item} />
                        </Box>
                    );
                }
                if (index === 0) {
                    return (
                        <Box key={item.id} ref={measureStartRef}>
                            <Component {...item} />
                        </Box>
                    );
                }
                return (
                    <Box key={item.id}>
                        <Component {...item} />
                    </Box>
                );
            })}
            {isLoadingEnd && <Box textAlign={'center'}>Loading...</Box>}
        </Box>
    );
};

export default InfiniteScrollContainer;
